{
    "FeedName": "FeedName",
    "SourceSystem": "SourceSystem",
    "ETLData": [
        {
            "EmployeeID": 761,
            "FirstName": "John",
            "LastName": "Doe",
            "Email": "",
            "TeamID": 1794,
            "LocationID": 45,
            "RegionID": 1,
            "CompanyID": 1,
            "LastUpdated": "2017-04-27 01:04:27.860",
            "Active": 1
        }
    ]
}